import Model from './model.js';

class ClientCountries extends Model {
  id = 0;
  regions = [];
  countries = [];
  shouldCheckDeliveryCountryInCustomerPortal = false;
  shouldCheckDeliveryCountryInPublicApi = false;
  shouldCheckDeliveryCountryInTranslator = true;

  mapForRequest() {
    return {
      regions: this.regions,
      countries: this.countries,
      shouldCheckDeliveryCountryInCustomerPortal: this.shouldCheckDeliveryCountryInCustomerPortal,
      shouldCheckDeliveryCountryInPublicApi: this.shouldCheckDeliveryCountryInPublicApi,
      shouldCheckDeliveryCountryInTranslator: this.shouldCheckDeliveryCountryInTranslator
    };
  }
}

export default ClientCountries;
